import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import styles from './Extract.module.css';
export function Extract(props) {
    return (_jsx("main", { className: styles.main, "data-testid": 'main-conta-pj-extract-root', children: props.extract }));
}
